export default __webpack_public_path__ + "static/custom-ca3061232725b3ea45227b0c18c83b9d.png";